import React, { useState } from 'react';

import BarChartHealthWrapper from '../barChartHealthWrapper/barChartHealthWrapper';
import MapChartHealthWrapper from '../mapChartHealthWrapper/mapChartHealthWrapper';
import LineChartHealthWrapper from '../lineChartHealthWrapper/lineChartHealthWrapper';

import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

// chart data
import Frage_2_Unterste_Einkommen_nominal from 'data/Frage-2_Unterste_Einkommen_nominal.json';
import Frage_2_Unterer_Mittelstand_nominal from 'data/Frage-2_Unterer_Mittelstand_nominal.json';
import Frage_2_Oberer_Mittelstand_nominal from 'data/Frage-2_Oberer_Mittelstand_nominal.json';
import Frage_2_Oberste_Einkommen_nominal from 'data/Frage-2_Oberste_Einkommen_nominal.json';

import Frage_2_Unterste_Einkommen_real from 'data/Frage-2_Unterste_Einkommen_real.json';
import Frage_2_Unterer_Mittelstand_real from 'data/Frage-2_Unterer_Mittelstand_real.json';
import Frage_2_Oberer_Mittelstand_real from 'data/Frage-2_Oberer_Mittelstand_real.json';
import Frage_2_Oberste_Einkommen_real from 'data/Frage-2_Oberste_Einkommen_real.json';

const ChartHealth2Wrapper = () => {
  const questionId = 2;
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const dataFilesNominal = [
    Frage_2_Unterste_Einkommen_nominal,
    Frage_2_Unterer_Mittelstand_nominal,
    Frage_2_Oberer_Mittelstand_nominal,
    Frage_2_Oberste_Einkommen_nominal,
  ];

  const dataFilesReal = [
    Frage_2_Unterste_Einkommen_real,
    Frage_2_Unterer_Mittelstand_real,
    Frage_2_Oberer_Mittelstand_real,
    Frage_2_Oberste_Einkommen_real,
  ];

  return (
    <div>
      <ChartTitleIntro number={questionId} title="Welche Umverteilungswirkung haben die Prämienzahlungen?">
        <p>
          Die folgenden Grafiken zeigen, ob die Krankenkassenprämien einer Einkommensgruppe über oder unter dem Durchschnitt liegen. Ist der Betrag
          einer Gruppe positiv, dann sind die Prämien dieser Personen höher als die des Durchschnitts. Ist der Betrag negativ, dann sind die Prämien
          in dieser Gruppe tiefer als die des Durchschnitts. So bedeutet ein Umverteilungswert von CHF 300 bei den untersten Einkommen, dass die
          Prämien der Personen dieser Gruppe jährlich CHF 300 höher sind als beim Bevölkerungsdurchschnitt.
        </p>
        <p>
          <em>
            Grafik 2.1 ermöglicht einen Vergleich zwischen den Einkommensgruppen innerhalb eines Kantons. Grafik 2.2 erlaubt einen interkantonalen
            Vergleich der Umverteilungswerte. In Grafik 2.3 ist die Entwicklung der Umverteilung über die Zeit abgebildet (real, zu Preisen des
            jüngsten verfügbaren Jahres). Hier erfahren Sie mehr zu <DataMethodLink />.
          </em>
        </p>
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs uppercase">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => setSelectedTab(0)}>
            {questionId}.1 Vergleich Einkommensgruppen
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => setSelectedTab(1)}>
            {questionId}.2 Interkantonaler Vergleich
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => setSelectedTab(2)}>
            {questionId}.3 Entwicklung über die Zeit
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.1 GRUPPENVERGLEICH UMVERTEILUNG PRÄMIENZAHLUNGEN</div>
            <BarChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Prämienzahlungen" />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.2 INTERKANTONALER VERGLEICH UMVERTEILUNG PRÄMIENZAHLUNGEN</div>
            <MapChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Prämienzahlungen" />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.3 ENTWICKLUNG UMVERTEILUNG PRÄMIENZAHLUNGEN</div>
            <LineChartHealthWrapper dataFiles={dataFilesReal} titlePrefix="Umverteilung Prämienzahlungen" />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default ChartHealth2Wrapper;
